import { createContext, ReactNode, use, useMemo } from "react";
import useSWR from "swr";
import { SWRApiError, swrConfigOptions, useFetcher } from "@/hooks/swr";
import { type FeatureMap } from "@/types/features";

const FeaturesContext = createContext<Partial<FeatureMap>>({});

interface FeaturesProviderProps {
  children: ReactNode;
}

export const FeaturesProvider = ({ children }: FeaturesProviderProps) => {
  const fetcher = useFetcher();

  const { data } = useSWR<Partial<FeatureMap>, SWRApiError>({ url: "/features" }, fetcher, {
    ...swrConfigOptions,
    revalidateOnFocus: false,
  });

  const features = useMemo(() => data ?? {}, [data]);

  return <FeaturesContext value={features}>{children}</FeaturesContext>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useFeaturesContext = (): Partial<FeatureMap> => {
  const context = use(FeaturesContext);
  if (!context) {
    throw new Error("useFeaturesContext must be used within a FeaturesProvider");
  }
  return context;
};
